"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgMessage = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_MESSAGE", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M.903 1.174a.582.582 0 0 1 .274-.267C1.707.659 3.537 0 8 0c4.463 0 6.292.659 6.823.907.12.056.214.15.274.267C15.348 1.67 16 3.27 16 6.5c0 3.23-.652 4.83-.903 5.326a.582.582 0 0 1-.274.267c-.33.155-1.164.468-2.823.683V15.5a.5.5 0 0 1-.828.377L7.8 13h.004c-4.321-.02-6.104-.662-6.627-.907a.582.582 0 0 1-.274-.267C.652 11.33 0 9.73 0 6.5c0-3.23.652-4.83.903-5.326ZM8 11c3.113 0 4.762-.335 5.5-.55.207-.626.5-1.877.5-3.95 0-2.073-.293-3.324-.5-3.95C12.762 2.335 11.113 2 8 2s-4.762.335-5.5.55C2.293 3.176 2 4.427 2 6.5c0 2.073.293 3.324.5 3.95.738.215 2.387.55 5.5.55Z" }))); };
exports.default = SvgMessage;
